import { Trans } from '@getpopsure/i18n-react';
import { legal } from '@getpopsure/private-constants';
import {
  QuestionnaireFormProps,
  QuestionnaireQuestions,
  ScreenProps as QuestionnaireScreenProps,
} from '@getpopsure/qnr-framework';
import { Button } from '@popsure/dirty-swan';
import classNames from 'classnames';
import { useSafeTranslation } from 'shared/i18n';

import styles from './style.module.scss';

// While it's called "continueButtonText" in Strapi UI, the ScreenProps type exposes "buttonText" instead of continueButtonText
type ScreenProps = Omit<QuestionnaireScreenProps, 'buttonText'> & {
  continueButtonText?: string;
};

export const LegalAndContinueButton = <
  Questionnaire extends QuestionnaireQuestions
>({
  showLegalNotice,
  continueButtonText,
  isSubmitValid,
  skipDetails,
  onSubmitValue,
}: {
  showLegalNotice?: boolean;
  continueButtonText?: string;
  isSubmitValid: boolean;
  skipDetails: ScreenProps['skipDetails'];
  onSubmitValue: QuestionnaireFormProps<Questionnaire>['onSubmitValue'];
}) => {
  const { t } = useSafeTranslation();

  return (
    <>
      {showLegalNotice && (
        <Trans i18nKey="generic.qnr.uploadDocuments.agreement">
          <p className="p-p mt24">
            By uploading any documents you agree to our{' '}
            <a
              className="p-a"
              href={legal.declarationDataProtection}
              target="_blank"
              rel="noopener noreferrer"
            >
              data processing agreement
            </a>
            .
          </p>
        </Trans>
      )}
      <div className="d-flex f-wrap c-gap8">
        <Button
          type="submit"
          disabled={!isSubmitValid}
          data-cy="button-continue"
          className={classNames('mt24 wmn3', styles.w100OnMobile)}
        >
          {continueButtonText ||
            t('signup.qnr.continueButton.text', 'Continue')}
        </Button>
        {skipDetails &&
        (skipDetails.onClick !== undefined || skipDetails.skipQuestion) ? (
          <Button
            onClick={() => {
              if (skipDetails.onClick) {
                skipDetails.onClick();
              } else if (skipDetails.skipQuestion) {
                onSubmitValue(skipDetails.skipQuestion.value || []);
              }
            }}
            className={`mt24 wmn2 ${styles.w100OnMobile}`}
            variant="textColor"
            data-cy="button-skip"
            type="button"
          >
            {skipDetails.title}
          </Button>
        ) : (
          skipDetails &&
          skipDetails.path && (
            <Button
              className={`p-btn--secondary mt24 wmn2 ${styles.w100OnMobile}`}
              href={skipDetails.path}
              as="a"
              data-cy="button-skip"
            >
              {skipDetails.title}
            </Button>
          )
        )}
      </div>
    </>
  );
};
